
import {interval as observableInterval,  Observable ,  Subscription } from 'rxjs';
import { Directive, ElementRef, AfterViewInit, HostListener, OnDestroy, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appFocusAlways],appFocusAlways',
    standalone: false
})
export class FocusAlwaysDirective implements AfterViewInit, OnDestroy, OnChanges {
  @HostBinding('attr.tabindex') tabindex = 0;
  // tslint:disable-next-line:no-input-rename
  @Input('appFocusAlways') disable = false;
  @Input() interval = 1;
  intervalSubscription: Subscription;
  constructor(private el: ElementRef) {
  }
  ngAfterViewInit() {
    this.intervalSubscription = observableInterval(+this.interval).subscribe(() => {
      this.el.nativeElement.focus();
    });
    if (this.disable && this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }
  ngOnDestroy() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (+this.interval > 1) {
      setTimeout(() => {
        if (this.disable && this.intervalSubscription) {
          this.intervalSubscription.unsubscribe();
        }
      }, +this.interval);

    }
  }
  @HostListener('click')
  click() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }
  @HostListener('keydown')
  keydown() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }
}
